import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-528dd4fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "loggedin" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/logout" }, "Logout", -1))
const _hoisted_6 = { class: "controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoSVG = _resolveComponent("LogoSVG")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(" Logged in as: " + _toDisplayString(_ctx.user.email) + " | ", 1),
      _createElementVNode("a", { href: _ctx.AdminUrl }, "Manage Game", 8, _hoisted_3),
      _hoisted_4,
      _hoisted_5
    ]),
    _createVNode(_component_LogoSVG, { class: "logo" }),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.user.hasActiveSession)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("button", {
              class: "start btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resumeSession && _ctx.resumeSession(...args)))
            }, "Resume Game"),
            _createElementVNode("button", {
              class: "start btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createSession && _ctx.createSession(...args)))
            }, "Start New Game")
          ], 64))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "start btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createSession && _ctx.createSession(...args)))
          }, "Start Game"))
    ]),
    _createElementVNode("button", {
      class: "help btn-link action-right",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.howToPlay && _ctx.howToPlay(...args)))
    }, " How to Play ")
  ]))
}